define(
  'classes/map',['underscore', 'async!https://maps.googleapis.com/maps/api/js?key=AIzaSyDjy1KlfeAFWsbY1B_D9cogMzR9hLJ-A44'],
  function(_) {

    var Map = function (div, restaurants, position) {
      var options = {
        minZoom: 13,
        styles: [{featureType: "poi", stylers: [{ visibility: "off" }]}]
      };

      // have we passed in a simple lat/lon array (individual restaurant)?
      if (typeof position.length != 'undefined' && position.length == 2) {
        options.center = new google.maps.LatLng(position[0], position[1]);
        options.zoom = 17;
      }
      var map = new google.maps.Map(document.getElementById(div), options);

      // have we passed abounding box (set of restaurants)?
      if (typeof position.intersects == 'function') {
        var padding = 0;
        map.fitBounds(position, padding);
      }

      map.div = div;
      map.loading_div = div + '-loading';
      map.info_window = new google.maps.InfoWindow({content: ''});

      if (restaurants !== undefined) {
        google.maps.event.addListener(map, 'tilesloaded', function() {
          centre = map.getCenter();
          restaurants.fetchWithinMap(map);
        });
        google.maps.event.addListener(map, 'dragend', function() {
          if (map.isBigDrag(centre)) {
            restaurants.fetchWithinMap(map);
            centre = map.getCenter();
          }
        });
      }

      return map;
    }

    Map.prototype = google.maps.Map.prototype;

    _.extend(Map.prototype, {
      isBigDrag: function (c1) {
        var c2 = this.getCenter();
        var x1 = c1.lat(), y1 = c1.lng();
        var x2 = c2.lat(), y2 = c2.lng();
        var distance = Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
        return (distance >= 0.001);
      },

      showLoading: function() {
        document.getElementById(this.loading_div).style.display = 'block';
      },

      hideLoading: function() {
        document.getElementById(this.loading_div).style.display = 'none';
      }

    });

    return Map;

  });
